<template lang='pug'>
  .edit-image
    .edit-image-thumbnail
      .edit-image-thumbnail-image(v-if='has_asset')
        div(
          v-if='is_video'
          v-html='thumbnail')
        img(
          v-else
          :src='thumbnail')
      .edit-image-thumbnail-placeholder(v-else-if='has_external_video')
        i.pbxx-icon.pbxx-icon-tv-play
      .edit-image-thumbnail-placeholder(v-else)
        i.pbxx-icon.pbxx-icon-crop-original
    .edit-image-options
      .edit-image-copy(v-if='has_asset || has_external_video')
        | {{ asset_name }}
      .edit-image-copy(v-else)
        | Upload {{ is_video ? "a video" : "an image" }} to get started
      el-button.edit-image-button(
        v-if='has_asset && !is_video && !is_hidden_temporarily'
        @click='cropping_modal=true'
        size='mini'
      ) Edit
      el-button.edit-image-button(
        @click='handle_digital_asset_modal'
        size='mini'
      ) {{ has_asset ? 'Replace' : 'Upload' }}
      el-input(
        v-show='false'
        v-model='widget.draft_content.asset_name'
        :name="widget.id"
        v-validate="'required'"
        :data-vv-as='get_field_name'
      )
      .error(v-if='errors.has(widget.id)')
        span {{ get_error_message }}
    .edit-image-setting(v-if='has_asset && !is_video && !hero')
      label
        | Image Size
      el-slider(
        :min='0'
        :max='100'
        v-model='asset_size'
        @change='change($event, "asset_size")')
    .edit-image-setting(v-if='has_asset && !is_video && !is_hidden_temporarily')
      label
        | Position
      el-select(
        v-model='asset_position'
        placeholder='Center'
        @change='change($event, "asset_position")')
        el-option(
          v-for="position in asset_position_options"
          :key="position.value"
          :label="position.label"
          :value="position.value")
    .edit-image-setting(v-if='has_asset && !is_video')
      label
        | Image Alt-Text
      el-input.edit-image-setting-text(
        v-model='alt_text'
        @change='change($event, "alt_text")'
      )
    .edit-image-setting(v-if='(has_asset && is_video) || has_external_video')
      label.edit-reverse_order-label
        | Autoplay
      el-switch(
        v-model='is_autoplay'
        @change='change(!is_autoplay, "is_autoplay")')

    el-dialog(title='Cropping Tool', :visible.sync='cropping_modal', width='60%', center, :append-to-body='true')
      .edit-cropper-image-wrapper
        img.edit-cropper-image(:src='image_url')
      .edit-cropper-control-wrapper
        .edit-cropper-control(v-for='(val, key) in crop_attributes')
          p.edit-cropper-label
            | {{ key }}
          el-slider.edit-cropper-slider(
            :min='0'
            :max='99'
            :show-input='true'
            v-model='(val)'
            @change='change_cropping_value(val, key)')
      span(
        slot='footer'
        class='dialog-footer')
        el-button(
          type='success'
          @click='apply_cropping')
          | Apply Changes
        el-button(
          type='primary'
          @click='reset_cropping')
          | Reset
        el-button(
          type='danger'
          @click='cancel_cropping')
          | Cancel

    el-dialog(
      title='Select Assets'
      v-if='show_modal'
      :visible.sync='digital_asset_modal'
      width='60%'
      center
      :append-to-body='true'
      :before-close='stop_video'
      )
      digital_asset_uploader(
        :associable_endpoint='get_associable_endpoint'
        :authorization='get_authorization'
        :multiple='false'
        :accept='resource_types'
        :show_input='is_video'
        :replace='true'
        :digital_asset_params='{}'
        :empty_uploader='false'
        :action_endpoint='cloudinary_endpoint'
        @upload_progress='on_upload_progress'
        @upload_success='on_upload_success'
        @digital_asset_created='on_digital_asset_created')
      .edit-campaign_assets(v-if='digital_asset_collection.length')
        p.edit-campaign_assets-title
          | Or choose an existing {{is_video ? 'video' : 'image'}}
        digital_asset_gallery.edit-campaign_assets-selector.has_selected_cards(
          ref='gallery'
          :digital_assets='digital_asset_collection'
          slot='gallery'
          @digital_asset_select_click='on_digital_asset_select_toggled'
          @digital_asset_card_click='on_digital_asset_select_toggled')
      span(
        slot='footer'
        class='dialog-footer')
        el-button(
          :disabled='!selected_digital_asset'
          type='primary'
          @click='select_asset')
          | {{this.widget.draft_content.asset_public_id ? 'Update' : 'Select'}}
</template>

<script>
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  import { db, config_obj } from '../utils/firebase'
  import cloudinary_initializer from '../mixins/cloudinary_initializer'

  export default {
    name: 'uploader',
    mixins: [
      cloudinary_initializer
    ],
    inject: {
      $validator: '$validator'
    },
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      asset_public_id: {
        type: String,
        required: false,
        default: ''
      },
      external_video_url: {
        type: String,
        required: false,
        default: ''
      },
      campaign: {
        type: Object
      },
      campaign_id: {
        type: String,
        required: true
      },
      brand_id: {
        type: String,
        required: true
      },
      accepted_resource_types: {
        type: String,
        default: 'image/*'
      },
      hero: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        resource_types: this.accepted_resource_types,
        show_modal: false,
        digital_asset_modal: false,
        cropping_modal: false,
        digital_asset_collection: [],
        digital_assets: [],
        crop_attributes: {...this.landing_page_widget.draft_content.crop_attributes},
        asset_size: this.landing_page_widget.draft_content.asset_size,
        asset_position: this.landing_page_widget.draft_content.asset_position,
        alt_text: this.landing_page_widget.draft_content.alt_text,
        widget: this.landing_page_widget,
        selected_digital_asset: false,
        asset_position_options: [
          {
            value: 0,
            label: 'Left'
          },
          {
            value: 50,
            label: 'Center'
          },
          {
            value: 100,
            label: 'Right'
          }
        ]
      }
    },
    async created() {
      const asset_collection = await db.collection(`brands/${this.brand_id}/campaigns/${this.campaign_id}/digital_assets`).get()
      const asset_array = []
      asset_collection.forEach(asset => asset_array.push(asset.data()))
      this.digital_assets = asset_array
    },
    watch: {
      digital_assets(vals) {
        const media_type = this.is_video ? 'video' : 'image';
        const filtered_assets = vals.filter(asset => {
          if(!asset.file && asset.upload_percentage < 100){
            return true
          }
          if(media_type === 'video'){
            return asset.resource_type === 'image' ? false : true
          }
          return asset.resource_type === 'image' ? true: false
        })
        const saved_asset_id = this.widget.draft_content.asset_public_id

        this.digital_asset_collection = filtered_assets.map(digital_asset=> {
          const asset_id = digital_asset.file ? digital_asset.file.public_id : null
          saved_asset_id === asset_id ? this.$set(digital_asset, 'is_selected', true) : this.$set(digital_asset, 'is_selected', false)
          return digital_asset
        })
      }
    },
    computed: {
      get_authorization() {
        return Cookies.get('token')
      },
      // TODO: Remove this. Hiding 'Edit' and 'Position' options until refined
      is_hidden_temporarily() {
        return true
      },
      is_video() {
        return this.widget.widget.name === "video" || this.widget.widget.name === "video_text"
      },
      is_autoplay() {
        return this.is_video ? this.widget.draft_content.is_autoplay : null
      },
      get_associable_endpoint() {
        return `${config_obj.api_base_path}/v2/campaigns/${this.campaign_id}`
      },
      has_asset() {
        return this.asset_public_id && this.asset_public_id !== ""
      },
      has_external_video() {
        return this.external_video_url && this.external_video_url !== ""
      },
      thumbnail() {
        if(this.has_asset) {
          if (this.is_video) {
            return this.cl.videoTag(this.asset_public_id, {
              width: '52',
              height: '52',
              dpr: 'auto',
              fetch_format: 'auto',
              quality: 'auto',
              crop: 'thumb',
              client_hints: true
            }).toHtml()
          } else {
            return this.cl.url(this.asset_public_id, {
              width: '52',
              height: '52',
              dpr: 'auto',
              fetch_format: 'auto',
              quality: 'auto',
              crop: 'thumb',
              client_hints: true
            })
          }
        }
      },
      image_url() {
        const x = this.crop_attributes.left/100,
        y = this.crop_attributes.top/100,
        angle = Math.round(this.crop_attributes.rotate/100 * 360),
        radius = this.crop_attributes.round < 99 ? this.crop_attributes.round : 'max'

        let width_percent = (100 - this.crop_attributes.right - this.crop_attributes.left)/100,
        height_percent = (100 - this.crop_attributes.bottom - this.crop_attributes.top)/100

        if (width_percent === 1 && height_percent === 1) {
          width_percent = null
          height_percent = null
        }

        if(this.asset_public_id) {
          return this.cl.url(this.asset_public_id, {
            dpr: 'auto',
            fetch_format: 'auto',
            width: width_percent,
            height: height_percent,
            x,
            y,
            angle,
            radius,
            quality: 'auto',
            crop: 'crop',
            client_hints: true
          })
        }
      },
      asset_name() {
        return this.widget.draft_content.asset_name
      },
      cloud_name() {
        return config_obj.cloudinary_cloud_name
      },
      cloudinary_endpoint() {
        return `https://api.cloudinary.com/v1_1/${this.cloud_name}/upload`
      },
      get_error_message() {
        // TODO: Figure out a better way to do this
        let error_message = this.errors.first(this.landing_page_widget.id)
        error_message = error_message.replace('+ text', '')
        error_message = error_message.replace('hero', 'image')
        error_message = error_message.replace('The url field is required.', '')
        error_message = error_message.replace('The url field is not a valid URL.', '')
        return error_message
      },
      get_field_name() {
        return this.is_video ? 'video' : 'image'
      }
    },
    methods: {
      handle_digital_asset_modal() {
        this.show_modal = true
        this.digital_asset_modal = true
      },
      stop_video() {
        this.show_modal = false
      },
      apply_cropping() {
        this.landing_page_widget.draft_content.crop_attributes = this.crop_attributes
        this.$emit('input', this.widget)
        this.cropping_modal = false
      },
      reset_cropping() {
        this.crop_attributes = {...this.landing_page_widget.draft_content.crop_attributes}
      },
      cancel_cropping() {
        this.reset_cropping()
        this.cropping_modal = false
      },
      change_cropping_value(val, key) {
        this.crop_attributes[key] = val
      },
      change(val, key) {
        this.landing_page_widget.draft_content[key] = val
        this.$emit('input', this.landing_page_widget)
      },
      on_digital_asset_created(digital_asset) {
        this.digital_assets.unshift(digital_asset)
      },
      on_upload_progress(event, file) {
        let digital_asset = this.find_digital_asset_from_file(file)
        digital_asset.upload_percentage = Math.floor(event.percent)
      },
      on_upload_success(event, file) {
        let digital_asset = this.find_digital_asset_from_file(file)
        digital_asset.file = file.response
      },
      on_digital_asset_select_toggled(digital_asset, index) {
        this.selected_digital_asset = digital_asset.is_selected ? false : digital_asset
        this.digital_asset_collection = this.digital_asset_collection.map((asset, i) => {
          i === index ? asset.is_selected = true : asset.is_selected = false
          return asset
        })
      },
      find_digital_asset_from_file(file) {
        return this.digital_assets.find(da => {
          return da.name === `${file.name}`
        })
      },
      select_asset() {
        let draft_content = _.merge(this.widget.draft_content, {
          asset_name: this.selected_digital_asset.name,
          asset_public_id: this.selected_digital_asset.file ? this.selected_digital_asset.file.public_id : '',
          external_video_url: this.selected_digital_asset.external_video_url
        })

        db.doc(`landing_pages/${this.campaign_id}/landing_page_widgets/${this.landing_page_widget.id}`).update({ draft_content })
        .then(() => {
          this.show_modal = false
          this.digital_asset_modal = false
        })
        .catch((e) => {
          console.log(e)
        })
      }
    }
  }
</script>

<style lang='scss'>
  // Override for elementUI
  .digital-asset-uploader {
    .el-upload.el-upload--text {
      width: 100%;
      .el-upload-dragger {
        border: none;
      }
    }
  }
</style>

<style lang='scss' scoped>
  .edit {
    @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
    &-cropper {
      &-image {
        width: auto;
        height : auto;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &-wrapper {
          height: 500px;
          width: 500px;
          margin: 0 auto;
          position: relative;
        }
      }
      &-control-wrapper {
        padding-left: 15px;
      }
      &-slider {
        margin-left: 7px;
      }
      &-label {
        margin: 0;
        text-transform: capitalize;
      }
    }
    padding: 20px;
    &-header {
      margin-bottom: 30px;
    }
    &-close,
    &-title {
      display: inline-block;
      text-align: center;
    }
    &-close {
      width: 5%;
    }
    &-title {
      width: 95%;
      text-transform: capitalize;
    }
    &-setting {
      margin-bottom: 20px;
      width: 100%;
      &-label {
        text-transform: capitalize;
        display: block;
      }
    }
    &-image {
      margin-bottom: 30px;
      &-setting {
        margin-top: 20px;
        label {
          width: 100%;
        }
      }
      &-thumbnail,
      &-options {
        display: inline-block;
        vertical-align: top;
        .error {
          color: red;
        }
      }
      &-options {
        max-width: 80%;
      }
      &-options {
        margin-left: 15px;
      }
      &-thumbnail {
        height: 52px;
        width: 52px;
        margin-right: 15px;
        &-image {
        }
        &-placeholder {
          text-align: center;
          color: get-color(gray);
          background: get-color(gray-lightest);
          height: 100%;
          font-size: 36px;
        }
      }
      &-copy {
        font-size: 12px;
        margin-bottom: 4px;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &-campaign_assets {
      border-top: 1px solid get-color(gray-lightest);
      &-title {
        color: get-color(gray-darkest);
        text-align: center;
        margin: 20px 0 0;
      }
      &-selector {
        height: 20vh;
        min-height: 150px;
        display: block;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }

  // force scroll bar for digital assets in modal
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,200,.5);
  }
</style>
